import { Link } from 'react-router-dom';
import { de } from '../lib/i18n/de';

export function NotFound() {
  return (
    <div className="pb-24 pt-20">
      <p className="font-sans text-xs font-medium uppercase tracking-widest text-stone-500">404</p>
      <h1 className="mt-3 font-serif text-4xl font-black leading-none tracking-tight text-stone-900 md:text-6xl">
        Diese Seite existiert nicht.
      </h1>
      <p className="mt-3 font-serif text-base italic text-stone-500">{de.errors.notFound}</p>
      <Link
        to="/"
        className="mt-8 inline-flex items-center justify-center rounded-sm bg-stone-900 px-6 py-3 font-sans text-xs font-medium uppercase tracking-widest text-white hover:bg-stone-800 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-stone-900 focus-visible:ring-offset-2"
      >
        {de.errors.notFoundCta} →
      </Link>
    </div>
  );
}
